/**
 * How the current session was authenticated. Kept in its own file (rather
 * than inline in WithAuthCubit) so partnerConfig.ts can import it without a
 * circular dependency on WithAuthCubit.ts — re-exported from WithAuthCubit
 * for existing consumers.
 */
export enum AuthenticationMethod {
  ANONYMOUS = "ANONYMOUS",
  PASSWORD = "PASSWORD",
  ROLE_SWITCH = "ROLE_SWITCH",
  EXISTING_TOKEN = "EXISTING_TOKEN",
  GOOGLE = "GOOGLE",
  SAML2 = "SAML2",
  TRANSCARENT_SSO = "TRANSCARENT_SSO",
  PERSONIFY_SSO = "PERSONIFY_SSO"
}
